import { useQuery } from '@tanstack/react-query'
import { type PdfTemplate, pdfApi } from '@/services/api/pdf'

/**
 * Fetches the list of registered PDF templates from the backend.
 *
 * Result is cached for 5 minutes — templates are effectively static within a
 * deploy, so refetching aggressively would just add noise.
 */
export function usePdfTemplates(subjectType?: string) {
  return useQuery({
    queryKey: ['pdf-templates'],
    queryFn: async () => {
      const res = await pdfApi.listTemplates()
      return res.templates
    },
    staleTime: 5 * 60 * 1000,
    select: (templates: PdfTemplate[]) =>
      subjectType ? templates.filter(t => t.subject_type === subjectType) : templates,
  })
}
